import { Grid, Stack } from '@mui/material'
import Filter from 'components/Filter/Filter'
import ListHeader from 'components/ListHeader/ListHeader'
import Loader from 'components/Loader/Loader'
import MissionList from 'components/MissionList/MissionList/MissionList'
import Search from 'components/Serch/Search'
import useCreateMission from 'hooks/useCreateMission'
import { useFilteredMissions } from 'hooks/useFilteredMissions'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { PATH } from 'utils/constants'

import style from './MissionList.module.css'

const MissionListPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { mutateAsync: createNewMission, error: createError, isPending } = useCreateMission()
  const { filteredMissions, setSearchInput, searchInput, isFetching, error, refetch } = useFilteredMissions()

  const createMission = async () => {
    const mission = await createNewMission()
    if (mission?.id) navigate(`${PATH.MISSION}${mission.id}`)
  }

  return (
    <div className={style.container}>
      <Stack direction={{ xs: 'column', sm: 'row' }} width="100%" spacing={1} marginTop={{ xs: 1, sm: 2, lg: 3 }}>
        <Search
          onSearch={value => {
            setSearchInput(value)
          }}
          searchInput={searchInput}
        />
        <Filter />
      </Stack>
      <Grid width="100%" xs={12} md={12} item marginTop={{ xs: 1, sm: 1, lg: 0 }}>
        <ListHeader
          onClickHeader={createMission}
          loading={isPending}
          buttonName={t('missions.createNew')}
          titleHeader={t('missions.title')}
          buttonStyled={style.button}
        />
        {(error || createError) && <div>{error?.message || createError?.message}</div>}
        {isFetching ? <Loader /> : <MissionList missions={filteredMissions} onMissionsUpdated={refetch} />}
      </Grid>
    </div>
  )
}

export default MissionListPage
